import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogOut, Loader2 } from 'lucide-react';

const LogoutPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/'); 
    }, 2500);

    return () => clearTimeout(timer); 
  }, [navigate]);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-slate-50 font-primary">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <div className="w-24 h-24 bg-white rounded-[2rem] shadow-2xl shadow-primary/10 flex items-center justify-center mb-8 mx-auto relative overflow-hidden group">
          <div className="absolute inset-0 bg-primary opacity-0 group-hover:opacity-5 transition-opacity" />
          <LogOut size={40} className="text-primary" />
        </div>
        
        <h1 className="text-3xl font-black text-slate-900 mb-3 tracking-tight">Logging you out</h1>
        <p className="text-slate-500 font-medium mb-10 italic">Thank you for your service today.</p>
        
        <div className="flex items-center justify-center gap-3 bg-white px-6 py-3 rounded-full border border-slate-100 shadow-sm">
          <Loader2 size={18} className="text-primary animate-spin" />
          <span className="text-sm font-bold text-slate-600 uppercase tracking-widest">Clearing Session...</span>
        </div>
      </motion.div>
      
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -ml-48 -mb-48" />
    </div>
  );
};

export default LogoutPage;
